// @flow
import React from 'react';
import styled from 'styled-components';
import { clearFix } from 'polished';
import shortid from 'shortid';

import { colors } from '../../../shared/styles';

const StyledRadioGroup = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;
    ${clearFix()} & label {
        font-size: 13px;
        display: block;
        padding: 6px 0;
    }

    & .input-wrapper {
        display: flex;
    }

    & .input-wrapper label {
        margin-right: 10px;
    }

    & .input-wrapper input {
        padding: 6px 10px;
        margin-left: 10px;
    }
`;

type RadioGroupProps = {
    disabled?: boolean,
    input: any,
    label: string,
    options: Array<any>,
};

const RadioGroup = (props: RadioGroupProps) => {
    const { disabled, input, label, options } = props;

    const id = shortid.generate();

    const optionsList = options
        ? options.map(option => {
              return {
                  value: option.value,
                  text: option.text,
              };
          })
        : [];

    return (
        <StyledRadioGroup>
            {label &&
                <label htmlFor={id}>
                    {label}:
                </label>}
            <div className="input-wrapper">
                {optionsList.map(option =>
                    <label key={option.value}>
                        <span>
                            {option.text}
                        </span>
                        <input
                            {...input}
                            value={option.value}
                            disabled={disabled}
                            type="radio"
                            id={id}
                            checked={
                                input.value && input.value === option.value
                            }
                        />
                    </label>
                )}
            </div>
        </StyledRadioGroup>
    );
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/shared/forms/RadioGroup.js